import { openAlertModal } from 'admin/actions/alert-modal';
import { hideLoadingSpinner, showLoadingSpinner } from 'admin/actions/loading-spinner';
import Textbox from 'admin/components/shared/Textbox';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactRouterPropTypes from 'react-router-prop-types';
import { bindActionCreators } from 'redux';
import { Button } from '../../../../atoms/Buttons';
import styles from './styles.scss';

class FilterForm extends Component {
  onSubmit = () => {
    this.props.onSearch();
  };

  render() {
    return (
      <div styleName="wrapper">
        <label htmlFor="terminal-name-filter">シリアル番号</label>
        <Textbox
          id="terminal-name-filter"
          name="serialNumber"
          styleName="terminal-name-filter"
          size={20}
          value={this.props.serialNumber}
          onChange={this.props.onChangeForm}
        />
        <Button onClick={this.onSubmit} variant="muted-outline">
          絞り込む
        </Button>
      </div>
    );
  }
}

FilterForm.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  onSearch: PropTypes.func.isRequired,
  onChangeForm: PropTypes.func.isRequired,
  serialNumber: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openAlertModal,
      showLoadingSpinner,
      hideLoadingSpinner,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CSSModules(FilterForm, styles))
);
